import React, { useEffect } from 'react';
import { useTailNumberContext } from '../../../../contexts/tail-number.context';
import { actionTypes } from '../../../../ducks/tail-number.duck';
import { getTailNumberStatus } from '../../../../selectors/tail-number.selector';
import TailNumbersView from './tail-numbers-list.view';

const TailNumbers: React.FC = () => {
  const { state, actions } = useTailNumberContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <TailNumbersView
      loading={
        getTailNumberStatus(state, actionTypes.TAIL_NUMBER_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default TailNumbers;
